import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseconfig';
import './Savings.css';

const StaffList = ({ onSelectStaff, selectedStaffId }) => {
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [queryText, setQueryText] = useState('');

  useEffect(() => {
    fetchStaffList();
  }, []);

  const fetchStaffList = async () => {
    try {
      setLoading(true);
      const usersRef = collection(db, 'users');
      const q = query(usersRef, where('role', '!=', 'admin'));
      const querySnapshot = await getDocs(q);
      
      const staff = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      setStaffList(staff);
    } catch (err) {
      console.error('Error fetching staff list:', err);
      setError('Failed to load staff list');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading staff list...</div>;
  if (error) return <div className="error-message">{error}</div>;

  const lower = queryText.trim().toLowerCase();
  const filtered = lower
    ? staffList.filter(s => (
        (s.displayName || '').toLowerCase().includes(lower) ||
        (s.email || '').toLowerCase().includes(lower) ||
        (s.role || '').toLowerCase().includes(lower)
      ))
    : staffList;

  return (
    <div className="staff-list">
      <h3>Select Staff Member</h3>
      <div className="form-group">
        <input
          type="text"
          placeholder="Search by name, email or role"
          value={queryText}
          onChange={(e) => setQueryText(e.target.value)}
        />
      </div>
      <div className="staff-grid">
        {filtered.map(staff => (
          <div
            key={staff.id}
            className={`staff-card ${selectedStaffId === staff.id ? 'selected' : ''}`}
            onClick={() => onSelectStaff(staff)}
          >
            <div className="staff-avatar">
              {staff.displayName ? staff.displayName[0].toUpperCase() : '👤'}
            </div>
            <div className="staff-info">
              <h4>{staff.displayName || 'Unknown'}</h4>
              <p>{staff.email}</p>
              <p className="staff-role">{staff.role}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StaffList; 